// Dummy change to force a fresh prod build/deploy after fixing missing
// BUGSNAG_API_KEY / MIXPANEL_TOKEN / REACT_APP_SEGMENT_WRITE_KEY prod secrets.
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import injectTapEventPlugin from "react-tap-event-plugin";

import * as session from "./modules/session/actions";

import configureStore, { history } from "./store";

import App from "./containers/App";

injectTapEventPlugin();

const store = configureStore();
store.dispatch(session.loadSavedAuth());

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Route component={App} />
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js